import { c as _c } from "react/compiler-runtime";
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerCreatePrecedenceClauseMutationRequest, GroupsControllerCreatePrecedenceClauseMutationResponse, GroupsControllerCreatePrecedenceClausePathParams, GroupsControllerCreatePrecedenceClause400, GroupsControllerCreatePrecedenceClause401, GroupsControllerCreatePrecedenceClause403, GroupsControllerCreatePrecedenceClause404, GroupsControllerCreatePrecedenceClause409 } from "../../models/documentGroupsController/GroupsControllerCreatePrecedenceClause";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { groupsControllerCreatePrecedenceClause } from "../../clients/document-groupsService/groupsControllerCreatePrecedenceClause";
import { mutationOptions, useMutation } from "@tanstack/react-query";
export const groupsControllerCreatePrecedenceClauseMutationKey = () => [{
  url: '/api/v1/documents/groups/documents/:documentId/precedence-clauses'
}] as const;
export type GroupsControllerCreatePrecedenceClauseMutationKey = ReturnType<typeof groupsControllerCreatePrecedenceClauseMutationKey>;
export function groupsControllerCreatePrecedenceClauseMutationOptions<TContext = unknown>(config: Partial<RequestConfig<GroupsControllerCreatePrecedenceClauseMutationRequest>> & {
  client?: typeof fetch;
} = {}) {
  const mutationKey = groupsControllerCreatePrecedenceClauseMutationKey();
  return mutationOptions<GroupsControllerCreatePrecedenceClauseMutationResponse, ResponseErrorConfig<GroupsControllerCreatePrecedenceClause400 | GroupsControllerCreatePrecedenceClause401 | GroupsControllerCreatePrecedenceClause403 | GroupsControllerCreatePrecedenceClause404 | GroupsControllerCreatePrecedenceClause409>, {
    documentId: GroupsControllerCreatePrecedenceClausePathParams["documentId"];
    data?: GroupsControllerCreatePrecedenceClauseMutationRequest;
  }, TContext>({
    mutationKey,
    mutationFn: async ({
      documentId,
      data
    }) => {
      return groupsControllerCreatePrecedenceClause(documentId, data, config);
    }
  });
}

/**
 * @description Creates a BY_USER precedence clause anchored to a citation on the governing document: either an existing user-authored CLAUSE annotation on that document (`annotationId`) or a `passage` (rendition, verbatim text, page anchor) from which a user annotation is written first. `entries` is the full stated order, ranks 1..N with no gaps; a null or omitted rank marks a stated exception. A governing document may hold several clauses. When the mutation changes the enclosing project's effective orders, relationship re-inference is notified.
 * @summary State an order of precedence for a governing document
 * {@link /api/v1/documents/groups/documents/:documentId/precedence-clauses}
 */
export function useGroupsControllerCreatePrecedenceClause(t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = options ?? {};
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutation: t3,
    client: t4
  } = t2;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const mutation = t5;
  let t6;
  if ($[6] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const config = t6;
  let mutationOptions;
  let queryClient;
  if ($[8] !== mutation) {
    ({
      client: queryClient,
      ...mutationOptions
    } = mutation);
    $[8] = mutation;
    $[9] = mutationOptions;
    $[10] = queryClient;
  } else {
    mutationOptions = $[9];
    queryClient = $[10];
  }
  let t7;
  if ($[11] !== mutationOptions.mutationKey) {
    t7 = mutationOptions.mutationKey ?? groupsControllerCreatePrecedenceClauseMutationKey();
    $[11] = mutationOptions.mutationKey;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mutationKey = t7;
  let t8;
  if ($[13] !== config) {
    t8 = groupsControllerCreatePrecedenceClauseMutationOptions(config);
    $[13] = config;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const baseOptions = t8 as UseMutationOptions<GroupsControllerCreatePrecedenceClauseMutationResponse, ResponseErrorConfig<GroupsControllerCreatePrecedenceClause400 | GroupsControllerCreatePrecedenceClause401 | GroupsControllerCreatePrecedenceClause403 | GroupsControllerCreatePrecedenceClause404 | GroupsControllerCreatePrecedenceClause409>, {
    documentId: GroupsControllerCreatePrecedenceClausePathParams["documentId"];
    data?: GroupsControllerCreatePrecedenceClauseMutationRequest;
  }, TContext>;
  let t9;
  if ($[15] !== baseOptions || $[16] !== mutationKey || $[17] !== mutationOptions) {
    t9 = {
      ...baseOptions,
      mutationKey,
      ...mutationOptions
    };
    $[15] = baseOptions;
    $[16] = mutationKey;
    $[17] = mutationOptions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return useMutation(t9, queryClient) as UseMutationResult<GroupsControllerCreatePrecedenceClauseMutationResponse, ResponseErrorConfig<GroupsControllerCreatePrecedenceClause400 | GroupsControllerCreatePrecedenceClause401 | GroupsControllerCreatePrecedenceClause403 | GroupsControllerCreatePrecedenceClause404 | GroupsControllerCreatePrecedenceClause409>, {
    documentId: GroupsControllerCreatePrecedenceClausePathParams["documentId"];
    data?: GroupsControllerCreatePrecedenceClauseMutationRequest;
  }, TContext>;
}